module.exports = vendor.ReactDOM;